export const smLinks = [
  {
    link: 'https://sa.linkedin.com/company/satelrealty',
    icon: 'logo-linkedin',
  },
  {
    link: 'https://x.com/Satelrealty',
    icon: 'logo-x',
  },
  {
    link: 'https://www.tiktok.com/@satelrealty',
    icon: 'logo-tiktok',
  },
  {
    link: 'https://www.snapchat.com/add/satelrealty',
    icon: 'logo-snapchat',
  },
  {
    link: 'https://www.youtube.com/@satelrealty',
    icon: 'logo-youtube',
  },
  {
    link: 'https://www.instagram.com/satelrealty',
    icon: 'logo-instagram',
  }
]
